<template>
  <v-dialog
      v-model="dialog"
      max-width="600px"
  >
    <v-card v-click-outside="closeDialog">
      <v-card-title class="d-flex justify-center dialog-title">
        <span class="text-h4">SMS KREDİNİZ YETERSİZ 😔</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="d-flex justify-center align-center">
            <p class="dialog-text">
              Ana Hesap Mevcut SMS kredisi: <strong>{{ this.$store.state.insufficientCreditDialog.credit }}</strong><br>
              İhtiyacınız olan SMS kredisi: <strong>{{ this.$store.state.insufficientCreditDialog.credit_to_be_taken }}</strong>
            </p>
            <v-col lg="9">
              <v-btn
                  color="success"
                  elevation="2"
                  x-large
                  class="w-100"
                  @click="toBuyPackageRoute"
              >
                SMS Paketi SATIN AL
              </v-btn>
            </v-col>

            <v-col lg="9" class="mt-4">
              <v-btn
                  color="warning"
                  outlined
                  x-large
                  class="w-100"
                  @click="closeDialog"
              >
                SMS Göndermekten Vazgeç
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import {mapGetters} from 'vuex'

export default {
  name: "InsufficientCreditDialog",
  computed: {
    ...mapGetters({
      dialog: 'getIcdStatus',
    }),
  },
  methods: {
    closeDialog() {
      this.$store.commit('updateIcdStatus', {status: false});
    },
    toBuyPackageRoute() {
      this.$store.commit('updateIcdStatus', {status: false});
      this.$router.push({name: "prices.index"});
    },
  },
}
</script>

<style scoped>
.dialog-title span {
  font-weight: bold;
  color: red;
}

.dialog-text {
  text-align: center;
  font-size: 16px;
  opacity: 1;
  color: #68696b;
}

.dialog-text b {
  font-weight: bold;
  font-size: 18px;
  color: #000;
}
</style>